export default __webpack_public_path__ + "static/media/authentication_light.32488a03.jpg";